export default "__VITE_ASSET__89ca833e__"